module.exports = __webpack_public_path__ + "static/media/jamal.caa829b4.jpg";